import { useCallback, useEffect, useRef, useState, useContext } from 'react'
import { history } from '../../navigation/history'
import { getExtraInfoCrid } from '../../services/api'
import { setLogger } from '../../utils/logger'
import { TemplateContext } from '../template/context'

const CANCELLATION_DATA_STORAGE_KEY = 'provi_cancellation_data'

const saveCancellationDataToStorage = data => {
  try {
    sessionStorage.setItem(CANCELLATION_DATA_STORAGE_KEY, JSON.stringify(data))
  } catch (error) {
    console.warn('Failed to save cancellation data to sessionStorage:', error)
  }
}

const loadCancellationDataFromStorage = () => {
  try {
    const storedData = sessionStorage.getItem(CANCELLATION_DATA_STORAGE_KEY)
    return storedData ? JSON.parse(storedData) : {}
  } catch (error) {
    console.warn('Failed to load cancellation data from sessionStorage:', error)
    return {}
  }
}

const clearCancellationDataFromStorage = () => {
  try {
    sessionStorage.removeItem(CANCELLATION_DATA_STORAGE_KEY)
  } catch (error) {
    console.warn('Failed to clear cancellation data from sessionStorage:', error)
  }
}

export const useTemplateCancellation = () => {
  const [cancellationData, setCancellationDataState] = useState(() => {
    return loadCancellationDataFromStorage()
  })
  const [canRequestCancellation, setCanRequestCancellation] = useState(true)
  const { selectCrid, setIsLoadingGlobal } = useContext(TemplateContext)

  const getExtraInfo = async () => {
    try {
      if (!window.location.href.includes('/cancelamento')) return
      setIsLoadingGlobal(true)

      if (!selectCrid) return

      const { data } = await getExtraInfoCrid(selectCrid?.id)
      setCanRequestCancellation(data.canRequestCancellation)
      setIsLoadingGlobal(false)
    } catch (error) {
      setLogger(error)
      setIsLoadingGlobal(false)
    }
  }

  useEffect(() => {
    getExtraInfo()
  }, [selectCrid])

  const modalRef = useRef()

  const openModal = useCallback(() => {
    modalRef.current.openModalFn()
  }, [modalRef])

  const closeModal = useCallback(() => {
    modalRef.current.closeModalFn()
  }, [modalRef])

  const goBackToSelectReason = useCallback(() => {
    return history.push('/cancelamento/motivo')
  }, [history])

  const setCancellationData = useCallback(newData => {
    setCancellationDataState(newData)
    saveCancellationDataToStorage(newData)
  }, [])

  useEffect(() => {
    const unlisten = history.listen(location => {
      if (!location.pathname.includes('/cancelamento')) {
        clearCancellationDataFromStorage()
      }
    })

    return () => {
      unlisten()
    }
  }, [])

  return {
    cancellationData,
    setCancellationData,
    openModal,
    closeModal,
    modalRef,
    goBackToSelectReason,
    canRequestCancellation
  }
}
